<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        xAxis: {
          type: "category",
          data: ["2024-08-01", "2024-08-02", "2024-08-03", "2024-08-04"]
        },
        yAxis: { type: "value" },
        series: [
          {
            type: "candlestick",
            data: [
              [20, 30, 10, 35],
              [40, 35, 30, 50],
              [31, 38, 20, 45],
              [38, 40, 32, 42]
            ]
          }
        ]
      }
    };
  }
};
</script>
